<template>
  <v-container fluid>
    <v-card flat>
      <v-card-title>
        <v-btn text small :to="{ name: 'RegistrationList' }">
          <v-icon left> mdi-arrow-left </v-icon>
          Back
        </v-btn>
        <v-spacer />
        <v-btn
          color="primary"
          outlined
          class="mx-2"
          @click="downloadLink(invoice)"
        >
          <v-icon left> mdi-download </v-icon>
          Download
        </v-btn>
        <v-btn color="primary" @click="pay">
          <v-icon left> mdi-send </v-icon>
          Pay KES
          {{ parseFloat(amountToPay) | currencyFormat }}
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-row>
          <v-col cols="8" offset="2">
            <v-card-text class="elevation-1 my-1">
              <pdf style="width: 100%" :src="invoice" />
            </v-card-text>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import FileMixin from "@brainspore/celadon-base/mixin/FileMixin";
import pdf from "vue-pdf";
import { AuthService } from "@/packages/dashboard/modules/auth";
export default {
  name: "ReinstatementInvoice",
  components: { pdf },
  mixins: [FileMixin],
  data: function () {
    return {};
  },
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch("Reinstatement/getReinstatements");
      if (to.params.code) {
        v.$store.dispatch(
          "Reinstatement/getReinstatementInvoice",
          to.params.code,
        );
        window.document.title = "KISEB::Pay For Reinstatement";
      }
    });
  },
  computed: {
    reinstatement() {
      return this.$route.params.code
        ? this.$store.getters["Reinstatement/reinstatementGetters"](
            "reinstatements",
          )
            .filter((el) => el.no === this.$route.params.code)
            .shift()
        : [];
    },
    invoice() {
      return this.$store.getters["Reinstatement/reinstatementGetters"](
        "reinstatementInvoice",
      );
    },
    user() {
      return AuthService.user;
    },
    amountToPay() {
      return this.reinstatement ? this.reinstatement.amountToBill : 0;
    },
  },
  methods: {
    pay: function () {
      const PhoneNo =
        this.user.profile.phoneNo.charAt(0) === "+"
          ? this.user.profile.phoneNo.slice(1)
          : this.user.profile.phoneNo.charAt(0) === "0"
            ? `254${this.user.profile.phoneNo.slice(1)}`
            : this.user.profile.phoneNo;

      const data = this.reinstatement;
      this.$confirm.show({
        title: "Reinstatement Payment",
        rejectLabel: "Pay Later",
        text: `Application Payment for Reinstatement No. ${data.no}`,
        onConfirm: () => {
          let payload = {
            payerID: data.profileID,
            sourceDocumentNo: data.no,
            serviceID: data.serviceCode,
            description: "Reinstatement Payment",
            amount: parseFloat(this.amountToPay).toString(),
            accountNo: PhoneNo,
            email: this.user.profile.email,
            idNumber: this.user.profile.identificationDocumentNo,
            name: `${this.user.profile.firstName} ${this.user.profile.lastName}`,
            success_url: `${process.env.VUE_APP_URL}${
              this.$router.resolve({ name: "ReinstatementList" }).href
            }`,
            fail_url: window.location.href,
          };

          payload = btoa(JSON.stringify(payload));
          // window.open(
          //   `${process.env.VUE_APP_PAYGATE_CHECKOUT_URL}/?payload=${payload}`,
          //   "_blank"
          // );
          this.$checkout.pay(payload);
        },
        onCancel: () => {
          Event.$emit("ApiInfo", "Payment cancelled");
          this.$router.replace({ name: "ReinstatementList" });
        },
      });
    },
  },
};
</script>

<style scoped></style>
